import { redirect as _redirect } from 'react-router';

import { isRouteModernized } from '@trello/router/migration';
import { getRouteIdFromPathname } from '@trello/router/routes';

/**
 * This is a wrapper around React Router's redirect function that we can use while in
 * the process of migrating routes to React Router. If the target route is modernized, it uses
 * React Router's redirect. If not, it performs a client-side redirect by updating the
 * browser's history and returning a Response with the appropriate status code.
 *
 * @param path - The path to redirect to.
 * @param status - The HTTP status code for the redirect (default is 302).
 * @returns A Response object for non-modernized routes, or never returns for modernized routes.
 */
export const redirect = (
  path: string,
  status: 301 | 302 | 303 | 307 | 308 = 302,
): Response | never => {
  const routeId = getRouteIdFromPathname(path);

  // If the route is modernized, throw React Router's redirect function
  if (isRouteModernized(routeId)) {
    throw _redirect(path, { status });
  } else {
    history.replaceState({}, '', path);
    return new Response(null, { status });
  }
};
